<template>
  <v-container fluid grid-list-xl pt-0>
    <v-layout wrap>
      <v-flex xs12>
        <material-card
          :title="pageTitle + ' (' + summaryMonth + ')'"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <div class="card-memo-1 text-white">
            <v-icon class="text-warning">mdi-checkbox-blank</v-icon>
            黃字代表不良率大於1%
          </div>
          <div class="card-memo-2 text-white">
            <v-icon class="text-danger">mdi-checkbox-blank</v-icon>
            紅字代表不良率大於3%
          </div>
          <v-form>
            <v-container py-0 class="mw-100">
              <v-layout wrap>
                <v-flex xs12 lg2>
                  <v-menu
                    v-model="summaryMonthMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryMonth"
                      label="時間"
                      prepend-icon="event"
                    />
                    <v-date-picker
                      v-model="summaryMonth"
                      :color="theme==='dark'?'danger':'general'"
                      type="month"
                      no-title
                      scrollable
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 lg2>
                  <v-autocomplete
                    v-model="summaryVendor"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryVendorMenu"
                    label="供應商（選填）"
                    clearable
                    outlined
                  />
                </v-flex>
<v-flex xs12 sm6 lg3>
                  <v-autocomplete
                    v-model="summaryAsusDeviceIsn"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryAsusDeviceIsnMenu"
                    label="料號（選填）"
                    clearable
                    outlined
                  />
                </v-flex>
                <v-flex  flex-small
                  mt-3
                  xs12
                  lg1
                  text-xs-right
                  d-flex
                  align-items-center>
                  <v-btn class="mx-0 font-weight-light" color="general" @click="doSubmit()">
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>

        <material-card>
          <div class="calendar">
            <div>
              <div style="margin-left: 70px;">
                <div v-for="(week, w) in WeekList" :key="'w'+w" class="calendar-week">
                  <span>{{ week }}</span>
                </div>
              </div>
              <div
                v-for="(list, d) in summaryMonthWeeksList"
                :key="'d'+d"
                :class="{'calendar-row-unfold': summaryWeeksMatch(list.weeks)}"
                class="calendar-row mr-0 ml-0"
              >
                <div class="calendar-weeks">
                  <router-link
                    :to="weekLink(list)"
                    class="calendar-week-num"
                  >
                    <span>W {{ list.weeks }}</span>
                  </router-link>
                  <router-link :to="weekLink(list)">
                    <v-btn title="檢示每週生產概要" class="black text-light pl-2 pr-2">
                      <v-icon>mdi-clipboard-text-outline</v-icon>
                    </v-btn>
                  </router-link>
                </div>
                <div
                  v-for="(days, dd) in list.date"
                  :key="'dd'+dd"
                  :class="{'calendar-around': days.around}"
                  class="calendar-day calendar-day-fail"
                >
                  <a style="cursor: default;">{{ days.day }}</a>
                  <v-icon
                    v-if="days.over"
                    class="calendar-day-icon"
                    @click="summaryWeeksArray(list.weeks)">mdi-apple-keyboard-control</v-icon>
                  <div
                    v-for="(fail, f) in days.failList"
                    :key="'f'+f"
                    class="calendar-fail">
                    <router-link
                      :to="statLink(fail, days.date)"
                      :style="'color:' + (fail.warningColor ? fail.warningColor : theme === 'dark' ? 'rgba(245,245,245,1)' : 'rgba(30,30,30,1)') + '!important;'"
                      :hover="'color:' + (fail.warningColor ? fail.warningColor : theme === 'dark' ? 'rgba(245,245,245,1)' : 'rgba(30,30,30,1)') + '!important;'"
                      target="_blank"
                      small>
                      <div>{{ formatFailRate(fail.failRate) }} </div>
                      <div>{{ fail.modelName }}</div>
                      <div>{{fail.deviceIsn}}</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </material-card>
      </v-flex>

      <v-flex flex_width_auto xs12>
        <material-card :title="'符合 '+summaryMonth+' 的總合數據'" color="deep-orange">
          <v-data-table
            :headers="headers"
            :items="responseFailTable"
            :pagination.sync="pagination"
            class="mt-3 elevation-1"
            multi-sort
            hide-actions
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="subheading font-weight-light text-general text--darken-3" v-text="header.text"/>
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.deviceIsn }}</td>
              <td>{{ item.processType }}</td>
              <td class="text-xs-right">{{ item.productionQty }}</td>
              <td class="text-xs-right">{{ item.failQty }}</td>
              <td class="text-xs-right">
                <v-chip :class="item.warningColor" small>{{ (item.failRate*100).toFixed(1) }}%</v-chip>
              </td>
              <td>{{ item.vendor }}</td>
              <td>
                <router-link
                  :to="statLink(item, DataStatistcStart, DataStatistcEnd)"
                  target="_blank"
                >
                  <v-btn class="mx-0 mr-3 font-weight-light small" color="primary">
                    <v-icon class="mr-2">mdi-chart-bar</v-icon>統計
                  </v-btn>
                </router-link>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="processingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        PROCESSING 處理中
      </p>
    </v-dialog>
    <v-dialog
      v-model="loadingView"
      :width="'calc(100% - ' + shrink + 'px)'"
      class="chart-view"
      persistent>
      <p style="letter-spacing: 5px;text-align: center !important;color: #ffffff;background-color: #000000dd;padding: 15px;width: 50%;margin: auto;">
        <img
          :src="Loading"
          style="width: 2rem;margin-bottom: 10px;">
        <br>
        LOADING 載入中
      </p>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :color="snackbarColor">
      {{ snackbarMsg }}
      <v-btn
        dark
        flat
        @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import qs from 'qs'
import Loading from '@/assets/img/loading.gif'
export default {
  name: 'CTQThermalPerformanceMonthly',
  data () {
    return {
      snackbar: false,
      snackbarColor: 'red',
      snackbarMsg: '',
      Loading,
      loadingView: false,
      processingView: false,
      summaryMonthMenu: false,
      summaryMonth: this.$moment(new Date()).format('YYYY-MM'),
      summaryVendor: '',
      summaryAsusDeviceIsn: '',
      summaryProcessType: 'VC',
      summaryStage: 'PL1',
      summaryVendorMenu: [],
      summaryAsusDeviceIsnMenu: [],
      summaryMonthWeeksList: [],
      summaryWeeksUnfoldList: [],
      responseFailTable: [],
      DataStatistcStart: '',
      DataStatistcEnd: '',
      WeekList: ['一', '二', '三', '四', '五', '六', '日'],
      pagination: { rowsPerPage: -1, sortBy: 'failRate', descending: true },
      headers: [
        { sortable: true, text: '料號', value: 'deviceIsn' },
        { sortable: true, text: '製程別', value: 'processType' },
        { sortable: true, text: '生產數量', value: 'productionQty', align: 'right' },
        { sortable: true, text: '總不良數量', value: 'failQty', align: 'right' },
        { sortable: true, text: '總不良率', value: 'failRate', align: 'right' },
        { sortable: true, text: '供應商', value: 'vendor' },
        { sortable: false, text: '熱測數據', value: '' }
      ]
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink']),
    pageTitle () {
      return (this.$route.meta && this.$route.meta.name) || '月 Performance 生產概況篩選'
    },
    pageBasePath () {
      const matched = this.$route.matched || []
      const last = matched[matched.length - 1] || {}
      const parent = matched[matched.length - 2] || {}
      const child = String(last.path || '').split('/')[0]
      return (parent.path || '/ctqThermalPerformance') + '/' + child
    }
  },
  watch: {
    summaryMonth (val) {
      this.summaryMonthMenu = false
      this.loadPartNo()
    },
    summaryVendor () {
      this.loadPartNo()
    }
  },
  mounted () {
    this.$store.dispatch('getAuthorize', '/thermalModule/pl1/vcMonthlyProdutionSummary')
      .then(response => {
        if (response.status === 'success' && response.data.accessible) {
          if (this.$route.params.searchDate) {
            this.summaryMonth = this.$route.params.searchDate
          }

          const body = {
            type: 'thermal_module'
          }
          this.$http.get('/api/system/pmsPath/getCodeAndNameListByType?' + qs.stringify(body)).then(res => res.data)
            .then(res => {
              if (res.status === 'success') {
                const data = res.data
                this.summaryVendorMenu = [
                  { text: 'All', value: 'All' },
                  ...data.map(item => ({
                    text: item.code,
                    value: item.code
                  }))
                ]

                // if (this.tempFactory !== '') {
                //   this.summaryVendor = this.tempFactory
                // }
              }
            })
          this.loadPartNo()
          this.doSubmit()
        } else if (response.errCode === 'E10000002') {
          const routeData = this.$router.resolve({ path: '/noEnter/E10000002' })
          localStorage.setItem('errormsg', response.errMsg)
          window.location.assign(routeData.href)
        } else {
          const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
          window.location.assign(routeData.href)
        }
      })
      .catch(err => {
        console.log(err)
        const routeData = this.$router.resolve({ path: JSON.parse(localStorage.getItem('user')).home })
        window.location.assign(routeData.href)
      })
  },
  methods: {
    loadPartNo () {
      const year = Number(String(this.summaryMonth).substr(0, 4))
      const month = Number(String(this.summaryMonth).substr(5, 2)) - 1
      const first = new Date(year, month, 1)
      const last = new Date(year, month + 1, 0)
      const queryStartDate = this.$moment(first).format('YYYY-MM-DD')
      const queryEndDate = this.$moment(last).format('YYYY-MM-DD')
      let url = '/api/thermalModule/selectOption/partNo?processType=' + encodeURIComponent(this.summaryProcessType || 'HP')
      if (this.summaryVendor) {
        url += '&vendor=' + encodeURIComponent(this.summaryVendor)
      }
      if (this.queryStage()) {
        url += '&stage=' + encodeURIComponent(this.queryStage())
      }
      url += '&queryStartDate=' + encodeURIComponent(queryStartDate)
      url += '&queryEndDate=' + encodeURIComponent(queryEndDate)
      this.$http.get(url).then(res => res.data)
        .then(res => {
          console.info(res)
          if (res.status === 'success') {
            this.summaryAsusDeviceIsnMenu = res.data
          }
        })
    },
    weekParam (list) {
      const monday = list.date && list.date[0] && list.date[0].date
      if (monday && this.$moment) {
        const m = this.$moment(monday)
        const y = String(m.isoWeekYear())
        const w = m.isoWeek()
        return y + (w < 10 ? ('0' + w) : String(w))
      }
      const y = String(this.summaryMonth).substr(0, 4)
      const w = list.weeks < 10 ? ('0' + list.weeks) : String(list.weeks)
      return y + w
    },
    weekLink (list) {
      const query = {}
      if (this.summaryVendor) query.vendor = this.summaryVendor
      if (this.summaryAsusDeviceIsn) query.deviceIsn = this.summaryAsusDeviceIsn
      return {
        path: '/thermalModule/pl1/vcWeeklyProdutionSummary/' + this.weekParam(list),
        query
      }
    },
    queryStage () {
      return this.summaryStage
    },
    toDateKey (value) {
      if (value == null || value === '') return ''
      if (Array.isArray(value) && value.length >= 3) {
        const mm = String(value[1]).padStart(2, '0')
        const dd = String(value[2]).padStart(2, '0')
        return value[0] + '-' + mm + '-' + dd
      }
      return String(value).replace(/\//g, '-').substr(0, 10)
    },
    formatFailRate (rate) {
      const n = Number(rate)
      if (!isFinite(n)) return '0.0%'
      return (n * 100).toFixed(1) + '%'
    },
    summaryWeeksArray (weeks) {
      const idx = this.summaryWeeksUnfoldList.indexOf(weeks)
      if (idx === -1) this.summaryWeeksUnfoldList.push(weeks)
      else this.summaryWeeksUnfoldList.splice(idx, 1)
    },
    summaryWeeksMatch (weeks) {
      return this.summaryWeeksUnfoldList.indexOf(weeks) > -1
    },
    statLink (item, date, daterange) {
      let url = '/thermalModule/pl1/vcTestDataStatistc?deviceIsn=' + item.deviceIsn +
        '&modelname=' + item.modelName +
        '&date=' + date +
        '&vendorpk=' + item.vendorPk +
        '&vendor=' + item.vendor +
        '&processType=' + (item.processType || this.summaryProcessType)
      if (daterange) url += '&daterange=' + daterange
      if ((item.processType || this.summaryProcessType) === 'VC') {
        url += '&stage=' + encodeURIComponent(this.summaryStage || 'All')
      }
      return url
    },
    buildCalendar (byDate) {
      const year = Number(String(this.summaryMonth).substr(0, 4))
      const month = Number(String(this.summaryMonth).substr(5, 2)) - 1
      const first = new Date(year, month, 1)
      const last = new Date(year, month + 1, 0)
      this.DataStatistcStart = this.$moment(first).format('YYYY-MM-DD')
      this.DataStatistcEnd = this.$moment(last).format('YYYY-MM-DD')

      const start = new Date(first)
      const dow = first.getDay() || 7
      start.setDate(first.getDate() - (dow - 1))
      const weeks = []
      let cursor = new Date(start)
      while (weeks.length < 7) {
        const weekNo = this.$moment(cursor).isoWeek()
        const days = []
        for (let i = 0; i < 7; i++) {
          const d = new Date(cursor)
          d.setDate(cursor.getDate() + i)
          const dateStr = this.$moment(d).format('YYYY-MM-DD')
          const around = d.getMonth() !== month
          const failList = around ? [] : (byDate[dateStr] || [])
          days.push({
            day: d.getDate(),
            date: dateStr,
            around,
            over: failList.length > 5,
            failList
          })
        }
        weeks.push({ weeks: weekNo, date: days })
        const weekEnd = new Date(cursor)
        weekEnd.setDate(cursor.getDate() + 6)
        if (weekEnd >= last) break
        cursor = new Date(cursor)
        cursor.setDate(cursor.getDate() + 7)
      }
      this.summaryMonthWeeksList = weeks
    },
    doSubmit () {
      this.loadingView = true
      const year = Number(String(this.summaryMonth).substr(0, 4))
      const month = Number(String(this.summaryMonth).substr(5, 2)) - 1
      const first = new Date(year, month, 1)
      const last = new Date(year, month + 1, 0)
      const body = {
        queryStartDate: this.$moment(first).format('YYYY-MM-DD'),
        queryEndDate: this.$moment(last).format('YYYY-MM-DD'),
        vendor: this.summaryVendor === 'All' || !this.summaryVendor ? '' : this.summaryVendor,
        deviceIsn: this.summaryAsusDeviceIsn === 'All' || !this.summaryAsusDeviceIsn ? '' : this.summaryAsusDeviceIsn,
        processType: this.summaryProcessType || 'HP',
        stage: this.queryStage()
      }
      console.info(body)
      this.$http.post('/api/thermalModule/failRateSummaryList', body).then(res => res.data)
        .then(res => {
          if (res.status === 'success') {
            this.responseFailTable = res.data
          }
        })
      this.$http.post('/api/thermalModule/dailyFailRateInfo', body).then(res => res.data)
        .then(res => {
          console.info(res)
          const byDate = {}
          if (res.status === 'success' && Array.isArray(res.data)) {
            res.data.forEach((day) => {
              const dateKey = this.toDateKey(day.productionDate || (day.productionData && day.productionData[0] && day.productionData[0].date))
              if (!dateKey) return
              byDate[dateKey] = day.productionData || []
            })
          }
          this.buildCalendar(byDate)
          this.loadingView = false
        })
    }
  }
}
</script>
<style>
.calendar-week-num {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}
.calendar-week-num:hover span {
  text-decoration: underline;
}
</style>
